export const STICKER_LABEL = 'Figurinha';

const field = (source, camel, snake) => source?.[camel] ?? source?.[snake];

export const isStickerAttachment = attachment => {
  const mediaType = field(attachment, 'wameMediaType', 'wame_media_type');

  return String(mediaType || '').toLowerCase() === 'sticker';
};

export const isStickerMessage = message => {
  const contentAttributes =
    field(message, 'contentAttributes', 'content_attributes') || {};
  const contentType = field(message, 'contentType', 'content_type');

  return (
    String(contentType || '').toLowerCase() === 'sticker' ||
    isStickerAttachment(contentAttributes)
  );
};
